export const ACTIONS = {
  REQUEST_GET_WELLBORE_ELEMENTS: 'REQUEST_GET_WELLBORE_ELEMENTS',
  REQUEST_GET_WELLBORE_ELEMENTS_FROM_WELLCOM:
    'REQUEST_GET_WELLBORE_ELEMENTS_FROM_WELLCOM',
};
